'use strict';

var handleADA = require('../common/handleADA');

function updateTotals(data) {
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    if ($('.grand-total-sum').length > 0) {
        $('.grand-total-sum').empty().append(data.totals.grandTotal);
    } else {
        $('.grand-total').empty().append(data.totals.grandTotal);
    }
    $('.sub-total').empty().append(data.totals.subTotal);
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }
}

module.exports = {
    changeGiftMessage: function () {
        $('#giftMessage').on('change', function (e) {
            e.preventDefault();
            var giftMessage = $('#giftMessage').val();
            var url = $('#giftMessage').data('change-message-method-url');
            var action;
            var checked = $('.gift')[0].checked;
            if (checked) {
                action = 'Insert';
            } else {
                action = 'Delete';
            }

            $.spinner().start();
            // Call --> CheckoutShippingServices-ChangeGiftMessage
            $.ajax({
                url      : url,
                type     : 'post',
                dataType : 'json',
                data     : {
                    action      : action,
                    isGift      : checked,
                    giftMessage : giftMessage
                }
            }).done(function () {
                $('.gift-message-summary').text(giftMessage);
                $.spinner().stop();
            }).fail(function () {
                $.spinner().stop();
            });
        });
    },

    changeGift: function () {
        $('.gift').on('change', function (e) {
            e.preventDefault();
            var url = $('.gift').data('select-gift-method-url');
            var action;
            if (this.checked) {
                action = 'Insert';
            } else {
                action = 'Delete';
            }

            $.spinner().start();
            // Call --> CheckoutShippingServices-ChangeGiftCheckBox
            $.ajax({
                url      : url,
                type     : 'post',
                dataType : 'json',
                data     : {
                    action      : action,
                    isGift      : this.checked,
                    giftMessage : $('#giftMessage').val()
                }
            }).done(function (data) {
                if (data && data.order && data.order.shipping && data.order.shipping.length > 0) {
                    data.order.shipping[0].isGift = $('.gift').prop('checked');
                }
                var totalGrossPrice = data.totalGrossPrice;
                data = data.order;
                updateTotals(data);

                if (action === 'Insert') {
                    $('.giftLine, .gift-textarea').removeClass('d-none');
                    $('.gift-message-block').removeClass('active');
                } else {
                    $('.giftLine, .gift-textarea').addClass('d-none');
                    $('.gift-message-block').addClass('active');

                    $('#giftMessage').val('');
                }
                if ($('klarna-placement').length > 0) {
                    document.querySelector('klarna-placement').dataset.purchaseAmount = (totalGrossPrice * 100).toFixed(0);
                    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
                    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
                }

                $.spinner().stop();
            }).fail(function () {
                $.spinner().stop();
            });
        });
    },

    ADAgift: handleADA.pressEnterItem('#labelIsGift')
};
